<template>
  <div>

    <header id="header">
      <router-link class="logo" :to="{ name: 'Start'}">
        <img src="/projects/hetfruit/templates/customerportal/images/logo.png" height="60">
      </router-link>
      <h3>Kinderdagverblijf bestelling</h3>
      <div>
        <router-link :to="{ name: 'DaycareOrders' }">
          <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32"><path fill="grey" d="M780-200v-156q0-60-39-99t-99-39H236l163 163-43 43-236-236 236-236 43 43-163 163h406q85 0 141.5 56.5T840-356v156h-60Z"/></svg>
        </router-link>
      </div>
    </header>

    <div class="content-container" v-if="data_is_fetched">

      <message-box v-if="page_is_edited_by_another_user" type="error">
        LET OP: deze bestelling wordt reeds door een andere gebruiker bewerkt
      </message-box>

      <form class="standard_order_form" method="post">
        <div class="form-section">

          <div class="section-header">
            <h3>Bestelling van {{ daycare_name }}
              <br>
              <span class="small">levering op {{ delivery_date }}</span>
            </h3>

            <div>
              <router-link class="btn" target="_blank"
                           :to="{ name: 'CrateLabel', params: { customername: daycare_name, date: delivery_date, city: company_city} }"
                           style="display: inline-flex; align-items: center; gap: 12px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                     class="bi bi-printer-fill" viewBox="0 0 16 16">
                  <path
                      d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                  <path
                      d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                </svg>
                <span>Sticker</span>
              </router-link>
            </div>
          </div>
        </div>

        <div class="form-section form-text-areas">
          <div class="form-label-text-area">
            <label>
              Opmerking:
            </label>
            <textarea id="remark" rows="4" v-model="remark"></textarea>
          </div>
          <div class="form-label-text-area">
            <label>
              Opmerking naar klant:
            </label>
            <textarea id="response_cust_remark" rows="4" v-model="response_cust_remark"></textarea>
          </div>
        </div>

        <div>
          <div style="display: flex; justify-content: end; align-items: center">
            <a style="flex-shrink: 1; text-decoration: underline; cursor: pointer;"
               @click="show_all_products = !show_all_products">
              <span v-show="!show_all_products">Toon al het fruit</span>
              <span v-show="show_all_products">Toon alleen besteld fruit</span>
            </a>
          </div>
        </div>


        <div v-for="category in categories_with_products" :key="category.category_id" class="form-section">
          <div class="section-header">
            <h3>{{ category.category_name }}</h3>
          </div>

          <div class="product_label" v-for="product in category.products" :key="product.id"
               v-show="show_all_products || order_products[product.id].amount > 0">
            <img :src="product.image" class="product-icon">
            <p class="product-text">{{ product.name }}</p>

            <div class="product-input">
              <div style="display:inline-block;" v-if="product.has_weight_input">
                Gewicht:
                <input-amount v-model:amount="order_products[product.id].weight" placeholder="Gewicht"
                              step="0.1" decimals="2"></input-amount>
                Kg
              </div>
            </div>
            <div class="product-input">
              <input-amount v-model:amount="order_products[product.id].amount"></input-amount>
            </div>
            <div class="product-price">
              {{
                displayPrice(order_products[product.id], product.price, product.has_weight_input)
              }}
            </div>

            <div class="product-check">
              <a @click="checked_products[product.id] = !checked_products[product.id]"
                 v-show="order_products[product.id].amount > 0">
                <img :src="getCheckProductIcon(product.id)" height="40"/>
              </a>
            </div>
          </div>
        </div>

        <div class="form-section">
          <div class="product_label">
            <img class="product-icon">
            <p class="product-text">Aantal stuks totaal</p>
            <div class="product-input"></div>
            <div class="product-input text-center">
              {{ total_amount_products }}
            </div>
            <div class="product-price"></div>
            <div class="product-check"></div>
          </div>
        </div>

      </form>

      <message-box v-if="weight_error" type="error">
        <span>Bij één of meer producten is het gewicht nog niet ingevuld of afwijkend.</span>
        <span v-for="message in weight_error_message" :key="message">
            {{message}}<br>
          </span>
      </message-box>

      <message-box v-if="checked_products_error" type="error">
        <span>Niet alle producten zijn aangevinkt. Is de bestelling compleet?</span>
      </message-box>

      <div style="display: flex; justify-content: space-around">
        <router-link class="btn btn-with-icon" :to="{ name: 'DaycareOrders' }">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path fill="grey" d="M780-200v-156q0-60-39-99t-99-39H236l163 163-43 43-236-236 236-236 43 43-163 163h406q85 0 141.5 56.5T840-356v156h-60Z"/></svg>
          Terug naar lijst</router-link>
        <a v-if="status ==='Geannuleerd'" class="btn warning" @click="activateDaycareOrder()">Reactiveer</a>
        <a v-else class="btn warning" @click="cancelDaycareOrder()">Annuleren</a>
        <a class="btn" @click="saveDaycareOrder(false)">Opslaan</a>
        <a class="btn" @click="saveDaycareOrder(true)">Opslaan en verwerkt</a>
      </div>

    </div>

  </div>
</template>

<script>

import ErrorHelper from "../helpers/ErrorHelper";
import MathHelper from "../helpers/MathHelper";
import InputAmount from '../components/InputAmount';
import {SimpleStore} from '../simplestore';
import MessageBox from "../components/MessageBox.vue";
// import { nextTick } from 'vue'


export default {
  name: "DaycareOrder",
  components: {MessageBox, InputAmount},
  props: ['orderid'],
  data() {
    return {
      SimpleStore,
      id: 0,
      remark: '',
      response_cust_remark:'',
      delivery_date: '',
      status: '',
      daycare_name: '',
      order_products: {}, // an object, because we want the product_id as keys
      categories_with_products: [],
      weight_error: false,
      checked_products_error: false,
      company_city: '',
      checked_products: {}, // an object, because we want the product_id as keys
      data_is_fetched: false,
      show_all_products: false,
      page_is_edited_by_another_user: false,
      max_kg: 1.5,
      weight_error_message:[],
    };
  },
  mounted() {
    this.getFruitProducts();
    this.getPageBeingEdited();
  },

  watch: {
    // update the check_products array if order_products changes, we only want to show check marks for product with an amount > 0
    order_products() {
      let checked_products = {};
      for (let product_id in this.order_products) {
        if (this.order_products[product_id].amount <= 0) continue;
        if (Object.hasOwn(this.checked_products, product_id)) continue;
        checked_products[product_id] = false;
      }

      this.checked_products = checked_products;
    }
  },

  computed: {
    total_amount_products() {
      let amount = 0;
      for (let product_id in this.order_products) {
        if (this.order_products[product_id].amount <= 0) continue;
        amount += parseInt(this.order_products[product_id].amount);
      }
      return amount;
    },

    all_products() {
      let all_products = [];
      for (let key in this.categories_with_products) {
        all_products.push(...Array.from(this.categories_with_products[key].products));
      }
      return all_products;
    }
  },

  methods: {

    getFruitProducts() {
      fetch('?action=getFruitproducts', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",
        },
        body: JSON.stringify({
          daycare_order_id: this.orderid,
        })
      }).then(res => res.json()).then((response) => {

        if (ErrorHelper.handleError(this, response)) return;

        this.categories_with_products = response.data;

        this.getDaycareOrder();
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },

    getDaycareOrder() {
      fetch('?action=getDaycareOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          daycare_order_id: this.orderid,
        })
      }).then(res => res.json()).then((response) => {

        if (ErrorHelper.handleError(this, response)) return;

        this.id = response.data.id;
        this.remark = response.data.remark;
        this.response_cust_remark = response.data.response_cust_remark;
        this.delivery_date = response.data.delivery_date;
        this.status = response.data.status;
        this.daycare_name = response.data.company_name;
        this.company_city = response.data.company_city;
        for (let index in response.data.order_products) {
          // set the id as key, for easy access
          this.order_products[response.data.order_products[index].id] = response.data.order_products[index];
        }
        this.setEmptyOrderProducts();
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },

    // we want an array with all the products, not only the ordered products
    setEmptyOrderProducts() {
      // create a product with amount 0, if it does not exist (not ordered)
      for (let index in this.all_products) {
        if (Object.hasOwn(this.order_products, this.all_products[index].id)) continue;
        this.order_products[this.all_products[index].id] = {
          id: this.all_products[index].id,
          amount: 0,
        };
      }

      this.data_is_fetched = true;
    },

    saveDaycareOrder(is_processed) {
      // validate weight first
      this.weight_error = false;
      this.weight_error_message =[];

      for (let product_id in this.order_products) {
        // not all products have weight input
        let product = this.all_products.find((element) => element.id == product_id);
        if (product.has_weight_input !== true) continue;
        // we dont have to insert the weight for products with no amount
        if (!this.order_products[product_id].amount || parseInt(this.order_products[product_id].amount) <= 0) continue;
        if (!this.order_products[product_id].weight || parseFloat(this.order_products[product_id].weight) <= 0 || parseFloat(this.order_products[product_id].weight)>parseFloat(this.order_products[product_id].amount * this.max_kg )) {
          this.weight_error_message.push("Controleer product: "+ product.name);
        }
      }

      if (this.weight_error_message.length>0) {
        this.weight_error = true;
        return;
      }

      // valideer of alle vinkjes gezet zijn
      this.checked_products_error = false;
      const active_products = Object.values(this.order_products).filter((product) => product.amount > 0).length;
      if(active_products > Object.keys(this.checked_products).length) {
        this.checked_products_error = true;
        return;
      }

      fetch('?action=saveDaycareOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          daycare_order_id: this.orderid,
          remark: this.remark,
          response_cust_remark: this.response_cust_remark,
          order_products: this.order_products,
          is_processed: is_processed
        })
      }).then(res => res.json()).then((response) => {
        if (ErrorHelper.handleError(this, response)) {
          this.$router.push({name: 'DaycareOrders'});
          return;
        }

        SimpleStore.addFlashMessage(response.message, 'success');
        this.$router.push({name: 'DaycareOrders'});
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },
    cancelDaycareOrder() {
      fetch('?action=cancelDaycareOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          daycare_order_id: this.orderid,
          remark: this.remark,
          response_cust_remark: this.response_cust_remark,
        })
      }).then(res => res.json()).then((response) => {
        if (ErrorHelper.handleError(this, response)) {
          this.$router.push({name: 'DaycareOrders'});
          return;
        }

        SimpleStore.addFlashMessage(response.message, 'success');
        this.$router.push({name: 'DaycareOrders'});
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },
    activateDaycareOrder() {
      fetch('?action=activateDaycareOrder', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          daycare_order_id: this.orderid,
          remark: this.remark,
          response_cust_remark: this.response_cust_remark,
        })
      }).then(res => res.json()).then((response) => {
        if (ErrorHelper.handleError(this, response)) {
          this.$router.push({name: 'DaycareOrders'});
          return;
        }

        SimpleStore.addFlashMessage(response.message, 'success');
        this.$router.push({name: 'DaycareOrders'});
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },
    getCheckProductIcon(product_id) {
      if (this.checked_products[product_id] === true) {
        return '/projects/hetfruit/templates/app/images/check_active.svg';
      }
      return '/projects/hetfruit/templates/app/images/check_not_active.svg';
    },

    displayPrice(product, price, has_weight_input) {
      if (has_weight_input) {
        let product_weight = product.weight;
        if (isNaN(parseFloat(product.weight))) {
          product_weight = 0;
        }
        return '€ ' + MathHelper.currencyFormat((parseFloat(product_weight) * parseFloat(price)), 2);
      }
      else {
        return '€ ' + MathHelper.currencyFormat((parseFloat(product.amount) * parseFloat(price)), 2);
      }
    },

    getPageBeingEdited() {
      fetch('?action=getPageBeingEdited&page=daycare_order&order_id=' + this.orderid, {
        method: "GET",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
      }).then(res => res.json()).then((response) => {
        this.page_is_edited_by_another_user = response.data;
      });
    },
  },
}

</script>

<style scoped>
.btn.warning{
  background-color: #D10017FF;
  border-color: #D10017FF;
  color: white;
}
</style>